export enum OrderStatus {
  New = 'new',
  Pending = 'pending',

  Rejected = 'rejected',
  Error = 'error',

  Open = 'open',
  PartiallyFilled = 'partially_filled',

  Filled = 'filled',

  Expired = 'expired',
  Canceled = 'canceled',
}
